import getEnv from '../utils/get-env';
import getConfig from '../utils/get-config';

function useEnvConfig() {
  return getConfig(getEnv(window.location.hostname));
}

export default useEnvConfig;
